import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './TamilFest.scss';

const tamilFestivals = [
  { id: 1, name: 'Pongal', img: 'https://c.ndtvimg.com/2020-01/b3ns635o_pongal-2020_625x300_11_January_20.jpg', description: "Pongal is a four-day-long harvest festival celebrated in Tamil Nadu, marking the beginning of the sun's northward journey." },
  { id: 2, name: 'Thai Pusam', img: 'https://upload.wikimedia.org/wikipedia/commons/f/f7/Penang_thaipusam_Kavadi_procceession.jpg', description: 'Thai Pusam is dedicated to Lord Murugan, celebrated with processions and acts of devotion.' },
  { id: 3, name: 'Tamil New Year', img: 'https://media.licdn.com/dms/image/v2/D5612AQHucUvYTAMf-A/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1713071748408?e=2147483647&v=beta&t=7xO4x-RnsXSzuza4oEn8gHIehcTpaE99Svl88o-oDD8', description: 'Tamil New Year or Puthandu is celebrated on the first day of the Tamil calendar with prayers and festive foods.' },
  { id: 4, name: 'Aadi Perukku', img: 'https://www.shutterstock.com/image-illustration/south-indian-women-lighting-floating-600nw-1352148230.jpg', description: 'Aadi Perukku is celebrated to pay tribute to water’s life-sustaining properties, especially rivers.' },
  { id: 5, name: 'Avani Avittam', img: 'https://giriaus.com/cdn/shop/articles/Avani_avittam_1200x600_crop_center.webp?v=1721290104', description: 'A Vedic ritual observed by Brahmins involving the change of sacred thread (yagnopaveetham).' },
  { id: 6, name: 'Navaratri', img: 'https://static.wixstatic.com/media/ce4c7b_1b7705b027e54e09a304ecd09accbb47~mv2.jpeg/v1/fill/w_385,h_256,al_c,lg_1,q_80/ce4c7b_1b7705b027e54e09a304ecd09accbb47~mv2.jpeg', description: 'Nine-night festival honoring the goddess Durga, with traditional dance and music.' },
  { id: 7, name: 'Karthigai Deepam', img: 'https://www.omspiritualshop.com/cdn/shop/articles/Black_and_White_Traditional_Indian_Diwali_Celebration_Instagram_Post_2000_x_1250_px_1024x1024.png?v=1732945752', description: 'The festival of lights celebrated by lighting rows of oil lamps in homes and temples.' },
  { id: 8, name: 'Vinayaka Chaturthi', img: 'https://akm-img-a-in.tosshub.com/indiatoday/images/media_bank/202309/ganesh-chaturthi-2023-wishes-to-celebrate-the-divine-festival-182626678-1x1.jpg?VersionId=lW5X79LP25.KZcNXCDZqEvcrJ8cgUD2L', description: "Celebration of Lord Ganesha's birthday, marked by installations of Ganesha idols and prayers." },
  { id: 9, name: 'Vaikasi Visakam', img: 'https://varnam.my/wp-content/uploads/2023/06/Vaikasi-Visakam_5.jpg', description: 'A festival celebrating the birth of Lord Murugan, with special pujas in temples.' },
  { id: 10, name: 'Ayyappan Vilakku', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMjx2prdG3f3dM3k04ujvO1uWug1JhHqxNlA&s', description: 'A religious gathering and lamp-lighting ceremony dedicated to Lord Ayyappa.' },
];

const TamilFest = () => {
  const [selectedFest, setSelectedFest] = useState(null);

  const handleCardClick = (fest) => {
    setSelectedFest(fest);
  };

  const handleClosePopup = () => {
    setSelectedFest(null);
  };

  return (
    <div className="tamilfest-container">
      <InnerNav />
      <div className="tamilfest-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Popular Tamil Festivals</h4>
        </div>

        <div className="festival-grid">
          {tamilFestivals.map((fest) => (
            <div className="festival-card" key={fest.id} onClick={() => handleCardClick(fest)}>
              <img 
              src={fest.img || 'https://s3.india.com/wp-content/uploads/2025/01/Makar-Sankranti-2025_-How-India-Comes-Together-For-A-Joyful-Harvest-Celebration.jpg'}
              alt={fest.name} />
              <p>{fest.name}</p>
            </div>
          ))}
        </div>

        {selectedFest && (
          <div className="avatar-popup" onClick={handleClosePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <img
              src={selectedFest.img || 'https://s3.india.com/wp-content/uploads/2025/01/Makar-Sankranti-2025_-How-India-Comes-Together-For-A-Joyful-Harvest-Celebration.jpg'}
               alt={selectedFest.name} />
              <h3>{selectedFest.name}</h3>
              <p>{selectedFest.description}</p>
              <button className="close-btn" onClick={handleClosePopup}>&times;</button>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default TamilFest;
